import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CategoryYearbooks {
  name: string;
  api_token: string;
}

export interface CategoryYearbooksListInfor {
  errors: unknown;
  categoryYearbooks: CategoryYearbooks;
  isAuthenticated: boolean;
}

@Module
export default class CategoryYearbooksModule
  extends VuexModule
  implements CategoryYearbooksListInfor
{
  errors = {};
  categoryYearbooks = {} as CategoryYearbooks;
  isAuthenticated = !!JwtService.getToken();

  get CategoryYearbooks() {
    return this.categoryYearbooksListData;
  }

  @Mutation
  [Mutations.CATEGORY_YEARBOOKS_LIST_DATA](CategoryYearbooks) {
    this.categoryYearbooksListData = CategoryYearbooks;
  }

  @Action
  [Actions.CATEGORY_YEARBOOKS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/dm_chitieu_niengiam", payload)
        .then((data) => {
          this.context.commit(Mutations.CATEGORY_YEARBOOKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CATEGORY_YEARBOOK_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("dm_chitieu_niengiam/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.CATEGORY_YEARBOOKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CATEGORY_YEARBOOK_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/dm_chitieu_niengiam",
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CATEGORY_YEARBOOKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CATEGORY_YEARBOOK_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/dm_chitieu_niengiam",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CATEGORY_YEARBOOKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
